import { useState, useEffect } from "react";
import { errorHandler } from "../ErrorHandler";
import Swal from "sweetalert2";
import { successMsg } from "../SuccessHandler";
import PastPostsTable from "../tables/PastPostsTable";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import InputMask from "react-input-mask";
import { MDBTooltip } from "mdb-react-ui-kit";
import ErrorCodes from "../../constants/ErrorCodes";
import { useUpdateFunctions, useSelectFunctions } from "../../functions";
import ConfirmDialog from "../utilities/ConfirmDialog";
import Rights from "../../constants/Rights";

const ScoreUnscore = ({
  raceSelected,
  userInfo,
  setRaceInfo,
  raceInfo,
  pastPosts,
  setPastPosts,
  racesTracks,
  setSessionNoLongerExists,
  voidTickets,
  callTicketVoidListFrom,
  selectAllTickets,
  setSelectAllTickets,
  scoreTickets,
  setCallTicketVoidListFrom,
  openTickets,
  setOpenTickets,
  isDisabled,
  setSelectedTicketsVoidScoreContainer,
  selectedTicketsVoidScoreContainer,
  callPastPostMethod,
  setCallPastPostMethod,
}) => {
  const [scorePastPost, setScorePastPost] = useState(false);
  const [errors, setErrors] = useState({});
  const { updateStatus, score, unscore } = useUpdateFunctions();
  const { getPastPost, getOpenBetsByRaceID } = useSelectFunctions();
  const userRightsList = JSON.parse(localStorage.getItem("UserRights")) || [];
  const [viewTickets, setViewTickets] = useState({
    viewOpenTickets: false,
    viewPastPostTickets: false,
  });

  useEffect(() => {
    setErrors({});
  }, [raceInfo.RaceID, raceInfo.RaceStatus]);

  let classOffDate = "",
    classOffDateT = "",
    invalidOffTime = "";

  if (errors) {
    if (errors.offTimeT || errors.offDate) {
      invalidOffTime = (
        <>
          <div
            style={{
              width: "100%",
              fontSize: "80%",
              color: "#dc3545",
            }}
          >
            {errors.offTimeT
              ? errors.offTimeT
              : errors.offDate
                ? errors.offDate
                : ""}
          </div>
        </>
      );

      errors.offTimeT && (classOffDateT = " is-invalid");
      errors.offTimeT && errors.offDate && (classOffDate = " is-invalid");
      !errors.offTimeT && errors.offDate && (classOffDate = " is-invalid");
      errors.offDate &&
        raceInfo.OffTimeT === "aN:aN:aN" &&
        (classOffDateT = " is-invalid");
    }
  }

  // OffTime handler
  const offDateChange = (dateO) => {
    const updatedErrors = { ...errors };
    if (dateO !== null) {
      delete updatedErrors.offDate;
      delete updatedErrors.offTimeT;
    } else {
      if (raceInfo.RaceStatus === "C") {
        updatedErrors.offDate = "Date is required";
      } else {
        delete updatedErrors.offDate;
        delete updatedErrors.offTimeT;
      }
    }
    setErrors(updatedErrors);

    if (dateO === null) {
      setRaceInfo({
        ...raceInfo,
        OffDate: "",
        OffTime: "",
        OffTimeT: raceInfo.OffTimeT || " : : ",
      });
    } else {
      const date = new Date(dateO);
      const dateString =
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "/" +
        ("0" + date.getDate()).slice(-2) +
        "/" +
        date.getFullYear();

      const isValidTime =
        raceInfo.OffTimeT &&
        /^\d{2}:\d{2}:\d{2}$/.test(raceInfo.OffTimeT.trim());
      const offTimeT = isValidTime ? raceInfo.OffTimeT : "00:00:00";

      setRaceInfo({
        ...raceInfo,
        OffDate: dateString,
        OffTimeT: offTimeT,
        OffTime: `${dateString} ${offTimeT}`,
      });
    }
  };

  const offTimeChange = (event) => {
    const value = event.target.value;
    const cleaned = value.replace(/[^0-9]/g, "");

    const updatedErrors = { ...errors };
    delete updatedErrors.offTimeT;
    delete updatedErrors.offDate;
    setErrors(updatedErrors);

    let dateToUse = raceInfo.OffDate;

    if (!dateToUse || isNaN(Date.parse(dateToUse))) {
      const today = new Date();
      const month = ("0" + (today.getMonth() + 1)).slice(-2);
      const day = ("0" + today.getDate()).slice(-2);
      const year = today.getFullYear();
      dateToUse = `${month}/${day}/${year}`;
    }

    const newRaceInfo = {
      ...raceInfo,
    };

    if (cleaned.trim() === "") {
      newRaceInfo.OffTimeT = " : : ";
      newRaceInfo.OffTime = `${dateToUse} 00:00:00`;
    } else {
      newRaceInfo.OffTimeT = value;
      newRaceInfo.OffTime = `${dateToUse} ${value}`;
    }

    const isValidTime =
      newRaceInfo.OffTimeT !== "aN:aN:aN" &&
      newRaceInfo.OffTimeT !== " : : " &&
      newRaceInfo.OffTimeT.trim() !== "";

    if (isValidTime) {
      newRaceInfo.OffDate = dateToUse;
    }

    setRaceInfo(newRaceInfo);
  };

  var headersErrorsList = "<tr><th>Errors List</th></tr>";
  //SCORE TICKETS FUNCTION
  const scoreTicket = () => {
    let bodyScoredErrors = [],
      tableScoredErrors = "";
    let swalLoadingModal;

    // Function to open a loading modal
    const openLoadingModal = () => {
      swalLoadingModal = Swal.fire({
        title: "Scoring <i class='fa fa-spinner fa-spin text-info'></i>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    };

    // Function to close the loading modal
    const closeLoadingModal = () => {
      if (swalLoadingModal) {
        swalLoadingModal.close();
      }
    };

    ConfirmDialog(
      `Do you want to <strong>Score</strong> the tickets?`,
      "No",
      "Yes, Score Tickets!",
    ).then(async (result) => {
      if (result.isConfirmed) {
        openLoadingModal(); // Open loading modal when confirming
        try {
          const res = await score(
            {
              RaceID: raceSelected,
              ScorePastPost: scorePastPost,
            },
            userInfo.LogonSessionID,
          );

          if (res?.error) {
            if (
              res.Result === ErrorCodes.InvalidSession ||
              res.Result === ErrorCodes.SessionNoLongerExists
            ) {
              setSessionNoLongerExists(true);
            }
            return;
          } else {
            if (viewTickets && viewTickets.viewPastPostTickets) {
              getPastPosts();
            }

            if (viewTickets && viewTickets.viewOpenTickets) {
              getOpenTickets();
            }
            if (res.ErrorsList.length !== 0) {
              res.ErrorsList.forEach((item, i) => {
                bodyScoredErrors.push(
                  "<tr key={i}><td class='tdTextAlign'>" +
                    item.ErrMsg +
                    "</td></tr>",
                );
              });
              tableScoredErrors =
                "<table class='table table-striped table-sm mt-2'><thead>" +
                headersErrorsList +
                "</thead><tbody>" +
                bodyScoredErrors.join("") +
                "</tbody></table>";
            }

            closeLoadingModal(); // Close loading modal when data is loaded

            Swal.fire({
              title: "<strong>SCORE</strong>",
              html:
                "<p class='sweetP'>Tickets Count: <strong>" +
                res.TicketsCount +
                "</strong></p> <p class='sweetP'>Tickets Scored Count: <strong>" +
                res.TicketsScoredCount +
                "</strong></p><p>Tickets Unscored Count: <strong>" +
                res.TicketsUnscoredCount +
                "</strong></p>" +
                tableScoredErrors,
            });
          }
        } catch (error) {
          errorHandler("An error occurred while fetching data.", error);
        } finally {
          closeLoadingModal(); // Ensure loading modal is closed in all cases
        }
      }
    });
  };

  //UNSCORE TICKETS FUNCTION
  const unscoreTicket = () => {
    let bodyUnscoredErrors = [],
      tableUnscoredErrors = "";
    let swalLoadingModal;

    // Function to open a loading modal
    const openLoadingModal = () => {
      swalLoadingModal = Swal.fire({
        title: "Unscoring <i class='fa fa-spinner fa-spin text-info'></i>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    };

    // Function to close the loading modal
    const closeLoadingModal = () => {
      if (swalLoadingModal) {
        swalLoadingModal.close();
      }
    };

    ConfirmDialog(
      `Do you want to <strong>Unscore</strong> the tickets?`,
      "No",
      "Yes, Unscore Tickets!",
    ).then(async (result) => {
      if (result.isConfirmed) {
        openLoadingModal(); // Open loading modal when confirming

        try {
          const res = await unscore(
            {
              RaceID: raceSelected,
            },
            userInfo.LogonSessionID,
          );

          if (res?.error) {
            if (
              res.Result === ErrorCodes.InvalidSession ||
              res.Result === ErrorCodes.SessionNoLongerExists
            ) {
              setSessionNoLongerExists(true);
            }
            return;
          } else {
            if (viewTickets && viewTickets.viewPastPostTickets) {
              getPastPosts();
            }

            if (viewTickets && viewTickets.viewOpenTickets) {
              getOpenTickets();
            }

            if (res.ErrorsList.length !== 0) {
              res.ErrorsList.forEach((item, i) => {
                bodyUnscoredErrors.push(
                  "<tr key={i}><td>" + item.ErrMsg + "</td></tr>",
                );
              });
              tableUnscoredErrors =
                "<table class='table table-striped table-sm mt-2'><thead>" +
                headersErrorsList +
                "</thead><tbody>" +
                bodyUnscoredErrors.join("") +
                "</tbody></table>";
            }

            closeLoadingModal(); // Close loading modal when data is loaded

            Swal.fire({
              title: "<strong>UNSCORED</strong>",
              html:
                "<p class='sweetP'>Tickets Count: <strong>" +
                res.TicketsCount +
                "</strong></p><p class='sweetP'>Tickets Scored Count: <strong>" +
                res.TicketsScoredCount +
                "</strong></p><p>Tickets Unscored Count: <strong>" +
                res.TicketsUnscoredCount +
                "</strong></p>" +
                tableUnscoredErrors,
            });
            setStatus("B", true);
          }
        } catch (error) {
          errorHandler("An error occurred while fetching data.", error);
        } finally {
          closeLoadingModal(); // Ensure loading modal is closed in all cases
        }
      }
    });
  };

  //Set Status function
  const setStatus = async (status, unscore) => {
    let raceStatus;
    if (unscore) {
      raceStatus = status;
    } else {
      raceStatus = raceInfo.RaceStatus;
    }

    const _errors = {};

    const isStatusCandB = raceStatus === "C";
    const offTimeTExists =
      raceInfo.OffTimeT &&
      raceInfo.OffTimeT !== "aN:aN:aN" &&
      raceInfo.OffTimeT.trim() !== "";
    const offDateInvalid =
      !raceInfo.OffDate ||
      raceInfo.OffDate === "aN/aN/NaN" ||
      raceInfo.OffDate === "undefined";

    if ((isStatusCandB || offTimeTExists) && offDateInvalid) {
      _errors.offDate = "Date is required";
    }

    if (offTimeTExists) {
      const timeRegex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;
      if (!timeRegex.test(raceInfo.OffTimeT)) {
        _errors.offTimeT = "Time must be in format hh:mm:ss";
      }
    }

    setErrors(_errors);

    if (Object.keys(_errors).length === 0) {
      const res = await updateStatus(
        {
          RaceID: raceSelected,
          Status: raceStatus,
          OffTime: raceInfo.OffTime,
        },
        userInfo.LogonSessionID,
      );

      if (res?.error) {
        if (
          res.Result === ErrorCodes.InvalidSession ||
          res.Result === ErrorCodes.SessionNoLongerExists
        ) {
          setSessionNoLongerExists(true);
        }
        return;
      } else {
        if (!unscore) {
          if (raceInfo.RaceStatus === "C" && res.ErrParams === "") {
            successMsg("Save Complete Status");
          }
          if (raceInfo.RaceStatus === "B" && res.ErrParams === "") {
            successMsg("Save Off Status");
          }
          if (raceInfo.RaceStatus === "O" && res.ErrParams === "") {
            successMsg("Save Open Status");
          }
          if (raceInfo.RaceStatus === "X" && res.ErrParams === "") {
            successMsg("Save Cancelled Status");
          }
        }

        setRaceInfo({
          ...raceInfo,
          RaceStatus: raceStatus,
        });

        if (res.Result === 0) {
          racesTracks.forEach((raceI) => {
            if (raceI.RaceID === raceSelected) {
              raceI.RaceStatus = raceStatus;
            }
          });
        }
      }
    }
  };

  useEffect(() => {
    if (
      (callTicketVoidListFrom &&
        callTicketVoidListFrom.fromScoreUnscorePastPost) ||
      (callTicketVoidListFrom.fromHeaderPastPost &&
        viewTickets.viewPastPostTickets)
    ) {
      getPastPosts();
    }

    if (
      (callTicketVoidListFrom &&
        callTicketVoidListFrom.fromScoreUnscoreOpenTickets) ||
      (callTicketVoidListFrom.fromHeaderPastPost && viewTickets.viewOpenTickets)
    ) {
      getOpenTickets();
    }
  }, [callTicketVoidListFrom]);

  useEffect(() => {
    if (raceSelected && raceSelected !== 0) {
      setViewTickets({ viewOpenTickets: false, viewPastPostTickets: false });
    }
  }, [raceSelected]);

  //Get Past Posts Function
  const getPastPosts = async () => {
    setPastPosts([]);
    setOpenTickets([]);
    setViewTickets({ viewOpenTickets: false, viewPastPostTickets: true });
    const res = await getPastPost(
      {
        RaceID: raceSelected,
        PostTime: raceInfo.PostTime,
      },
      userInfo.LogonSessionID,
    );

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      if (res.PastPostList.length === 0 && !callPastPostMethod) {
        Swal.fire({
          icon: "warning",
          text: "No Past Posts to display!",
        });
        setPastPosts([]);
        setOpenTickets([]);
      }
      setPastPosts(res.PastPostList);
      setCallTicketVoidListFrom({});
      setCallPastPostMethod(false);
    }
  };

  //Get Open Tickets Function
  const getOpenTickets = async () => {
    setPastPosts([]);
    setOpenTickets([]);
    setViewTickets({ viewOpenTickets: true, viewPastPostTickets: false });
    const res = await getOpenBetsByRaceID(
      {
        RaceID: raceSelected,
      },
      userInfo.LogonSessionID,
    );

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      if (res.RaceTicketMainList.length === 0 && !callPastPostMethod) {
        Swal.fire({
          icon: "warning",
          text: "No Open Tickets to display!",
        });
        setPastPosts([]);
        setOpenTickets([]);
      }
      setOpenTickets(res.RaceTicketMainList);
      setCallTicketVoidListFrom({});
      setCallPastPostMethod(false);
    }
  };

  if (
    raceInfo.OffTimeSystem === "00:00:00" ||
    raceInfo.OffTimeSystem === "21:00:00"
  ) {
    raceInfo.OffTimeSystem = "";
  }
  let offDateS;

  if (
    raceInfo.OffDateSystem.toString() === "01/01/2001" ||
    raceInfo.OffDateSystem.toString() === "12/31/1899"
  ) {
    offDateS = "";
  } else {
    offDateS = raceInfo.OffDateSystem;
  }

  const onChange = (e) => {
    setRaceInfo({
      ...raceInfo,
      [e.target.name]: e.target.value,
      LastModUsername: localStorage.getItem("userName"),
    });
  };

  const dateInputFormat = "MM/dd/yyyy";

  const calculateMinDate = () => {
    if (raceInfo.RaceDate) {
      const tracksDatePlusOne = new Date(raceInfo.RaceDate);
      tracksDatePlusOne.setDate(tracksDatePlusOne.getDate() + 1);
      return tracksDatePlusOne;
    }
    return null;
  };

  const toggleScorePastPostT = () => {
    setScorePastPost(!scorePastPost);
  };

  return (
    <div>
      <div
        style={{ margin: "0 auto", width: "100%", backgroundColor: "#f2f2f2" }}
      >
        <div className="row mr-2 ml-2">
          <div className="col-sm-4 col-lg-3 mt-1">
            <div className="form-group" key="offTime">
              <label
                htmlFor="inputCity"
                className="lead"
                style={{ fontSize: "20px" }}
              >
                Off time{" "}
                <p
                  style={{ margin: "0px", color: "#17a2b8", fontSize: "16px" }}
                >
                  (System Time)
                </p>
              </label>
              {raceInfo.OffTimeSystem ? (
                <p
                  className="lead mt-1"
                  style={{ margin: "0px", color: "#888888" }}
                >
                  {offDateS} {raceInfo.OffTimeSystem}
                </p>
              ) : (
                <p
                  className="lead mt-1"
                  style={{ margin: "0px", color: "#888888", fontSize: "15px" }}
                >
                  Off Time System not available
                </p>
              )}
            </div>
          </div>
          <div className="col-sm-4 col-lg-3 mt-1 mb-2">
            <div className="form-group mb-0" key="offTime">
              <label
                htmlFor="inputCity"
                className="lead"
                style={{ fontSize: "20px" }}
              >
                Off time
                <p
                  style={{ margin: "0px", color: "#17a2b8", fontSize: "16px" }}
                >
                  (Track Local Time)
                </p>
              </label>

              <DatePicker
                selected={Date.parse(raceInfo.OffDate)}
                dateFormat={dateInputFormat}
                className={"form-control" + classOffDate}
                wrapperClassName="datePicker"
                id="offTime"
                name="offTime"
                autoComplete="off"
                placeholderText="Date"
                onChange={offDateChange}
                minDate={calculateMinDate()}
              />
              <InputMask
                className={"form-control" + classOffDateT}
                mask="99:99:99"
                maskChar=" "
                id="offTimeT"
                name="offTimeT"
                step="1"
                value={raceInfo.OffTimeT}
                onChange={offTimeChange}
              />
            </div>
            {invalidOffTime}
          </div>
          <div className="col-sm-4 col-lg-3 mt-1">
            <label
              htmlFor="inputCity"
              className="lead"
              style={{ fontSize: "20px" }}
            >
              Status
            </label>
            <p></p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                paddingTop: "2px",
              }}
            >
              <select
                className="form-control mr-1"
                id="RaceStatusScore"
                name="RaceStatus"
                value={raceInfo.RaceStatus}
                onChange={onChange}
                style={{
                  paddingTop: "4px",
                  paddingBottom: "3px",
                }}
              >
                <option value={"O"}>Open</option>
                <option value={"B"}>Off</option>
                <option value={"C"}>Completed</option>
                <option value={"X"}>Cancelled</option>
              </select>
              {!isDisabled && (
                <MDBTooltip
                  tag="i"
                  wrapperProps={{ href: "#" }}
                  title="Save Status"
                >
                  <i
                    className="fas fa-save"
                    style={{
                      color: "#28a745",
                      fontSize: "25px",
                      cursor: "pointer",
                    }}
                    onClick={() => setStatus()}
                  ></i>
                </MDBTooltip>
              )}
            </div>
          </div>
          {userRightsList.find(
            (right) => right.FormName === Rights.FRM_SCORE_TICKETS,
          ) && (
            <div className="col-sm-6 col-lg-3 mt-1">
              <label
                htmlFor="inputCity"
                className="lead"
                style={{ fontSize: "20px", margin: "0px" }}
              >
                Score/Unscore
              </label>

              <p></p>
              <div className="scoreUnscoreForm">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => unscoreTicket()}
                  style={{
                    width: "80px",
                  }}
                >
                  Unscore
                </button>

                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => scoreTicket()}
                  style={{ width: "80px" }}
                >
                  Score
                </button>
              </div>
              <div className="custom-control custom-switch">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="switchScoreEvent"
                  name="scorePastPostT"
                  onClick={() => toggleScorePastPostT()}
                />
                <label
                  className="custom-control-label "
                  htmlFor="switchScoreEvent"
                  style={{ color: "#17a2b8", fontSize: "18px" }}
                >
                  Score PastPost Tickets
                </label>
              </div>
            </div>
          )}
        </div>
        <div className="row mr-2 ml-2 mt-2">
          <div className="col-sm-12">
            <button
              type="button"
              className="btn btn-info"
              data-toggle="modal"
              data-target="#openBetsModal"
              onClick={() => getOpenTickets()}
            >
              View Open Tickets
            </button>
            <button
              type="button"
              className="btn btn-info"
              data-toggle="modal"
              data-target="#pastPostsModal"
              onClick={() => getPastPosts()}
            >
              View Past Posts Tickets
            </button>
          </div>
        </div>
      </div>

      {pastPosts.length !== 0 && (
        <PastPostsTable
          pastPosts={pastPosts}
          voidTickets={voidTickets}
          setSelectedTicketsVoidScoreContainer={
            setSelectedTicketsVoidScoreContainer
          }
          selectedTicketsVoidScoreContainer={selectedTicketsVoidScoreContainer}
          selectAllTickets={selectAllTickets}
          setSelectAllTickets={setSelectAllTickets}
          scoreTickets={scoreTickets}
          callFrom={"PastPost"}
        />
      )}
      {openTickets.length !== 0 && (
        <PastPostsTable
          pastPosts={openTickets}
          voidTickets={voidTickets}
          setSelectedTicketsVoidScoreContainer={
            setSelectedTicketsVoidScoreContainer
          }
          selectedTicketsVoidScoreContainer={selectedTicketsVoidScoreContainer}
          selectAllTickets={selectAllTickets}
          setSelectAllTickets={setSelectAllTickets}
          scoreTickets={scoreTickets}
          callFrom={"OpenTickets"}
        />
      )}
    </div>
  );
};

export default ScoreUnscore;
